export const networkDeviceConstants = {
    NETWORK_DEVICE_LIST_REQUEST: "NETWORK_DEVICE_LIST_REQUEST",
    NETWORK_DEVICE_LIST_SUCCESS: "NETWORK_DEVICE_LIST_SUCCESS",
    NETWORK_DEVICE_LIST_FAILURE: "NETWORK_DEVICE_LIST_FAILURE",
    NETWORK_DEVICE_LIST_CLEAR: "NETWORK_DEVICE_LIST_CLEAR",

    NETWORK_DEVICE_BY_ID_REQUEST: "NETWORK_DEVICE_BY_ID_REQUEST",
    NETWORK_DEVICE_BY_ID_SUCCESS: "NETWORK_DEVICE_BY_ID_SUCCESS",
    NETWORK_DEVICE_BY_ID_ERROR: "NETWORK_DEVICE_BY_ID_ERROR",

    NETWORK_DEVICE_SIMPLE_MODEL_REQUEST: "NETWORK_DEVICE_SIMPLE_MODEL_REQUEST",
    NETWORK_DEVICE_SIMPLE_MODEL_SUCCESS: "NETWORK_DEVICE_SIMPLE_MODEL_SUCCESS",
    NETWORK_DEVICE_SIMPLE_MODEL_FAILURE: "NETWORK_DEVICE_SIMPLE_MODEL_FAILURE",

    NETWORK_DEVICE_REMOVE_FAILURE: "NETWORK_DEVICE_REMOVE_FAILURE",

    NETWORK_DEVICE_LOADER_SHOW: "NETWORK_DEVICE_LOADER_SHOW",
    NETWORK_DEVICE_LOADER_HIDE: "NETWORK_DEVICE_LOADER_HIDE",

    NETWORK_DEVICE_VALIDATION_FORM: "NETWORK_DEVICE_VALIDATION_FORM",

    NETWORK_DEVICE_TOASTER_DANGER: "NETWORK_DEVICE_TOASTER_DANGER",

    NETWORK_DEVICE_DROPDOWN_LIST: "NETWORK_DEVICE_DROPDOWN_LIST"
};
